import { render, staticRenderFns } from "./EditRealworksCredentialsForm.vue?vue&type=template&id=66219431&"
import script from "./EditRealworksCredentialsForm.vue?vue&type=script&lang=ts&"
export * from "./EditRealworksCredentialsForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditRealworksCredentialsForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports